// @flow
import React from "react";
import SecurityCode from "../../../svg/facilities/security_code.svg";
import "./securityCodeIcon.scss";

const SecurityCodeIcon = () => (
  <SecurityCode className="c-security-code-icon" />
);

export default SecurityCodeIcon;
